import React, { FC } from 'react';
import { Button } from 'antd';
import NotificationActionWrapper from './NotificationActionWrapper';
import ManageAllNotificationPreference from './ManageAllNotificationPreference';
import { getNotificationLabelFromDetails } from '../../utils/NotificationUtils';

interface UnsubscribeCardProps {
	notificationDetails: any;
	unsubscribing: boolean;
	onUnsubscribe: () => void;
	onCancel: () => void;
}

const UnsubscribeCard: FC<UnsubscribeCardProps> = ({
	notificationDetails,
	unsubscribing,
	onUnsubscribe,
	onCancel,
}): React.ReactElement => {
	return (
		<NotificationActionWrapper>
			<div className="h5medium">Unsubscribe from:</div>
			<div className="h2medium">{getNotificationLabelFromDetails(notificationDetails)}</div>
			<div className="flex w-full flex-col justify-center gap-4 px-4">
				<Button type="primary" size="large" loading={unsubscribing} onClick={onUnsubscribe}>
					Confirm
				</Button>
				<Button type="primary" ghost size="large" onClick={onCancel}>
					Cancel
				</Button>
			</div>
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default UnsubscribeCard;
